/**
 * FBSBancaSUMAK
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ActualizarContactoME } from '../model/actualizarContactoME';
import { AdicionarContactoME } from '../model/adicionarContactoME';
import { BloquearContactoME } from '../model/bloquearContactoME';
import { ListarContactosUsuarioME } from '../model/listarContactosUsuarioME';
import { ListarContactosUsuarioMS } from '../model/listarContactosUsuarioMS';
import { ObtenerContactoInternoME } from '../model/obtenerContactoInternoME';
import { ObtenerContactoInternoMS } from '../model/obtenerContactoInternoMS';
import { ObtenerContactoME } from '../model/obtenerContactoME';
import { ObtenerContactoMS } from '../model/obtenerContactoMS';
import { Unit } from '../model/unit';
import { VerificaNumeroCuentaME } from '../model/verificaNumeroCuentaME';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ContactoService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiV10ContactoActualizarContactoPost(body?: ActualizarContactoME, observe?: 'body', reportProgress?: boolean): Observable<Unit>;
    public apiV10ContactoActualizarContactoPost(body?: ActualizarContactoME, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Unit>>;
    public apiV10ContactoActualizarContactoPost(body?: ActualizarContactoME, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Unit>>;
    public apiV10ContactoActualizarContactoPost(body?: ActualizarContactoME, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Unit>('post',`${this.basePath}/api/v1.0/Contacto/ActualizarContacto`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiV10ContactoAdicionarContactoPost(body?: AdicionarContactoME, observe?: 'body', reportProgress?: boolean): Observable<Unit>;
    public apiV10ContactoAdicionarContactoPost(body?: AdicionarContactoME, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Unit>>;
    public apiV10ContactoAdicionarContactoPost(body?: AdicionarContactoME, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Unit>>;
    public apiV10ContactoAdicionarContactoPost(body?: AdicionarContactoME, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Unit>('post',`${this.basePath}/api/v1.0/Contacto/AdicionarContacto`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiV10ContactoBloquearContactoPost(body?: BloquearContactoME, observe?: 'body', reportProgress?: boolean): Observable<Unit>;
    public apiV10ContactoBloquearContactoPost(body?: BloquearContactoME, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Unit>>;
    public apiV10ContactoBloquearContactoPost(body?: BloquearContactoME, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Unit>>;
    public apiV10ContactoBloquearContactoPost(body?: BloquearContactoME, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Unit>('post',`${this.basePath}/api/v1.0/Contacto/BloquearContacto`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiV10ContactoListarContactosUsuarioPost(body?: ListarContactosUsuarioME, observe?: 'body', reportProgress?: boolean): Observable<ListarContactosUsuarioMS>;
    public apiV10ContactoListarContactosUsuarioPost(body?: ListarContactosUsuarioME, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ListarContactosUsuarioMS>>;
    public apiV10ContactoListarContactosUsuarioPost(body?: ListarContactosUsuarioME, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ListarContactosUsuarioMS>>;
    public apiV10ContactoListarContactosUsuarioPost(body?: ListarContactosUsuarioME, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ListarContactosUsuarioMS>('post',`${this.basePath}/api/v1.0/Contacto/ListarContactosUsuario`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiV10ContactoObtenerContactoInternoPost(body?: ObtenerContactoInternoME, observe?: 'body', reportProgress?: boolean): Observable<ObtenerContactoInternoMS>;
    public apiV10ContactoObtenerContactoInternoPost(body?: ObtenerContactoInternoME, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ObtenerContactoInternoMS>>;
    public apiV10ContactoObtenerContactoInternoPost(body?: ObtenerContactoInternoME, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ObtenerContactoInternoMS>>;
    public apiV10ContactoObtenerContactoInternoPost(body?: ObtenerContactoInternoME, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ObtenerContactoInternoMS>('post',`${this.basePath}/api/v1.0/Contacto/ObtenerContactoInterno`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiV10ContactoObtenerContactoPost(body?: ObtenerContactoME, observe?: 'body', reportProgress?: boolean): Observable<ObtenerContactoMS>;
    public apiV10ContactoObtenerContactoPost(body?: ObtenerContactoME, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ObtenerContactoMS>>;
    public apiV10ContactoObtenerContactoPost(body?: ObtenerContactoME, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ObtenerContactoMS>>;
    public apiV10ContactoObtenerContactoPost(body?: ObtenerContactoME, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ObtenerContactoMS>('post',`${this.basePath}/api/v1.0/Contacto/ObtenerContacto`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiV10ContactoVerificaNumeroCuentaPost(body?: VerificaNumeroCuentaME, observe?: 'body', reportProgress?: boolean): Observable<Unit>;
    public apiV10ContactoVerificaNumeroCuentaPost(body?: VerificaNumeroCuentaME, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Unit>>;
    public apiV10ContactoVerificaNumeroCuentaPost(body?: VerificaNumeroCuentaME, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Unit>>;
    public apiV10ContactoVerificaNumeroCuentaPost(body?: VerificaNumeroCuentaME, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Unit>('post',`${this.basePath}/api/v1.0/Contacto/VerificaNumeroCuenta`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
